
import { configureStore } from '@reduxjs/toolkit';
import salesOrdersReducer from './Slice/salesOrdersSlice';
import indentsReducer from './Slice/indentSlice';
import materialTransferReducer from './Slice/materialTransferSlice';
import grnListReducer from './Slice/goodsReceivedSlice';
import foodAdvanceReducer from './Slice/foodAdvanceSlice';
import dweListReducer from './Slice/dailyWorkEntrySlice';
import subconBillingReducer from './Slice/subconBillingSlice';
import subconAdvanceReducer from './Slice/subconAdvanceSlice';
import purchaseOrdersReducer from './Slice/purchaseOrdersSlice';
import workOrdersReducer from './Slice/workOrdersSlice';
import invoicesReducer from './Slice/invoicesSlice';
import creditNoteUiReducer from './Slice/creditNoteUiSlice'; 


export const store = configureStore({
  reducer: {
    salesOrders: salesOrdersReducer,
    indents: indentsReducer, 
    materialTransfer: materialTransferReducer,
    grnList: grnListReducer, 
    foodAdvance: foodAdvanceReducer,
    dweList: dweListReducer,
    subconAdvance: subconAdvanceReducer,
    subconBilling: subconBillingReducer,
    purchaseOrders: purchaseOrdersReducer,
    workOrders: workOrdersReducer,
    invoices: invoicesReducer,
    creditNoteUi: creditNoteUiReducer,
  },
});